import AnalyticsLoadingState from "../../AnalyticsLoadingState";

interface MermaidLoadingOverlayProps {
  label: string;
}

const MermaidLoadingOverlay = ({ label }: MermaidLoadingOverlayProps) => (
  <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-white/95">
    <AnalyticsLoadingState label={label} />
  </div>
);

export default MermaidLoadingOverlay;
